/** @jsxImportSource @emotion/react */

import { Redo2 as Redo2Icon } from 'lucide-react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import history from 'ud-ui/components/fabric-canvas/addons/history';
import UDTippy from 'ud-ui/components/tippy';
import { selectActiveModal, selectFabricManager } from '../../../../store/editor/selectors';
import { IconButton, IconWrapper } from './styles';

export function Redo() {
  const activeModal = useSelector(selectActiveModal);
  const fabricManager = useSelector(selectFabricManager);
  const [isActive, setIsActive] = React.useState(history.isInit() ?? history.redoIsActive());

  const onClickRedo = () => {
    if (!fabricManager) return;
    history.redo();
  };

  useEffect(() => {
    history.history.subscribe(() => {
      setIsActive(history.redoIsActive());
    });
    history.index.subscribe(() => {
      setIsActive(history.redoIsActive());
    });
  }, []);

  return (
    <UDTippy disabled={Boolean(activeModal)} content={'Вперед'} size="xs">
      <span style={{ display: 'inline-block' }}>
        <IconButton onClick={onClickRedo} disabled={!isActive} tabIndex={0}>
          <IconWrapper icon={<Redo2Icon size={20} strokeWidth={1.5} />} />
        </IconButton>
      </span>
    </UDTippy>
  );
}
